<template>
  <MainHeader :list_updated_at="list_updated_at" ></MainHeader>

  <div class="itemlist mt-8">
    <ItemDialog :initial-visible="dialog" :input_type="input_type" :target_item="target_item" @closed="dialogclose"
      @updateflag="updateflag"></ItemDialog>

    <v-container>
      <template v-for="(item, key, index) in filteredItemList" :key="index">
        <div class="section-title">{{ key }}</div>
        <template v-for="(inner_item, inner_index) in item" :key="inner_index">
          <v-row v-show="inner_item.type == this.$store.state.operation_type" justify="center">
            <v-col cols="12" sm="12">
              <v-card class="item-card" color="white" elevation="2" @click="openDialog(inner_item)" hover>
                <div class="d-flex flex-no-wrap justify-start">
                  <transition name="fade-transition" mode="out-in">
                  <v-img :src="inner_item.ext
                    ? this.$store.state.img_baseurl + this.$store.state.user_info.user_id + '/' + inner_item.iid + inner_item.ext
                    : this.$store.state.img_baseurl + 'default/noimage.png'" class="item-image"/>
                  </transition>
                  <div class="item-details">
                    <v-card-title class="item-title">{{ inner_item.name }}</v-card-title>

                    <v-card-subtitle class="item-subtitle d-flex align-center">
                      <v-icon small class="mr-1">mdi-tag</v-icon>
                      {{ $t('item_list.category_label') }}: {{ getCategoryName(inner_item.cat) }}
                    </v-card-subtitle>

                    <v-card-subtitle class="item-subtitle d-flex align-center">
                      <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
                      {{ $t('item_list.expiry_label') }}: {{ inner_item.ex_date }}
                    </v-card-subtitle>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- 10個ごとに広告を表示 -->
          <v-row v-if="(inner_index + 1) % 10 === 0" justify="center">
            <v-col cols="12" sm="12">
              <!-- AdSense広告コード -->
              <ListAdSense />
            </v-col>
          </v-row>
        </template>
      </template>

      <!-- リストの最後に広告を追加 -->
      <v-row justify="center">
        <!-- <ListAdSense /> -->
      </v-row>

    </v-container>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import ItemDialog from '@/components/ItemDialog.vue';
import ListAdSense from '@/components/ListAdSense.vue';

export default {
  name: 'ItemListView',
  components: {
    MainHeader,
    ItemDialog,
    ListAdSense
  },
  data() {
    return {
      login_error: "",
      item_list: {},
      list_updated_at: "",
      dialog: false,
      input_type: "update",
      target_item: null,
    };
  },
  computed: {
    filteredItemList() {
      return Object.entries(this.item_list).reduce((acc, [key, items]) => {
        const filteredItems = items.filter(item => item.type == this.$store.state.operation_type);
        if (filteredItems.length > 0) {
          acc[key] = filteredItems;
        }
        return acc;
      }, {});
    },
    categoryOptions() {
      // Store からカテゴリーリストを取得
      return this.$store.state.category_list;
    }
  },
  mounted: async function () {
    await this.getitem();
    if (this.$store.state.category_list.length == 0) {
      await this.getuserinfo();
    }
  },
  methods: {
    getitem: async function () {
      let jsonbody = {};
      jsonbody.api_type = "getitem";
      jsonbody.user_id = this.$store.state.user_info.user_id;

      await this.axios
        .post(this.$store.state.api_baseurl + "getitem", jsonbody, this.$store.state.post_headers)
        .then((res) => {
          this.item_list = res.data.item_list;
          this.list_updated_at = res.data.updated_at;
        })
        .catch((e) => {
          if (e.response.status == 401) {
            localStorage.removeItem('no-foodloss');
          }
          let errmsg = this.$t('error.errmsg_1');
          alert(e.response.data + errmsg);
          this.$router.push({ name: "home" });
        });
    },
    getuserinfo: async function () {
      let jsonbody = {};
      jsonbody.api_type = "userinfo";
      jsonbody.user_id = this.$store.state.user_info.user_id;

      await this.axios
        .post(this.$store.state.api_baseurl + "userinfo", jsonbody, this.$store.state.post_headers)
        .then((res) => {
          this.$store.commit("set_category_list", res.data.category);
        })
        .catch((e) => {
          if (e.response.status == 401) {
            localStorage.removeItem('no-foodloss');
          }
          let errmsg = this.$t('error.errmsg_1');
          alert(e.response.data + errmsg);
          this.$router.push({ name: "home" });
        });
    },
    getCategoryName(cat_id) {
      // category_list から cat_id を name に変換
      const category = this.categoryOptions.find(cat => cat.cat_id === cat_id);
      return category ? category.name : this.$t('item_dialog.unknown');
    },
    openDialog: function (item) {
      this.target_item = item;
      this.dialog = true;
    },
    dialogclose() {
      this.target_item = null;
      this.dialog = false;
    },
    updateflag() {
      this.$router.go({ path: this.$router.currentRoute.path, force: true });
    }
  }
}
</script>

<style scoped>
.v-container{
  padding: 8px;
}
.itemlist {
  padding: 20px 5px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin: 20px 0;
}

.item-card {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
}

.item-card:hover {
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.item-image {
  width: 125px;
  height: 125px;
  /* 画像の高さをカードに合わせる */
  object-fit: cover;
  border-radius: 8px;
}

.item-details {
  margin-left: 5px;
}

.item-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.item-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 2px;
}
</style>
